export const NAVIGATION_TO_SCROLL = 'NAVIGATION_TO_SCROLL'
